package com.zq.my_official_website

enum class SitePage(val title: String) {
    Home("首页"),
    Product("产品"),
    Plan("方案"),
    Partners("合作伙伴"),
    About("关于我们"),
}

fun SitePage.toTopNavIndex(): Int = when (this) {
    SitePage.Home -> 0
    SitePage.Product -> 1
    SitePage.Plan -> 2
    SitePage.Partners -> 3
    SitePage.About -> 4
}

fun sitePageFromTopNavIndex(index: Int): SitePage = when (index) {
    0 -> SitePage.Home
    1 -> SitePage.Product
    2 -> SitePage.Plan
    3 -> SitePage.Partners
    4 -> SitePage.About
    else -> SitePage.Home
}

